// extracted by mini-css-extract-plugin
module.exports = {"HalfHalf":"index__HalfHalf___3aq-C"};